import { createFileRoute } from '@tanstack/react-router'
import StudyText from '@/features/study-text'

export const Route = createFileRoute('/_authenticated/study-text/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <StudyText />
}
